import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from './base-url-params-filter';
import { CompanyPickerField } from 'shared/ui/formik-fields/company-picker';

export const CompanyUrlParamsFilter = ({ queryParamName, label, size = 'medium', withNonSelect }: BaseUrlParamsFilterProps) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field
        fullWidth
        name={queryParamName}
        label={label}
        clearable={true}
        size={size}
        withNonSelectOption={withNonSelect}
        component={CompanyPickerField}
      />
    </BaseUrlParamsFilter>
  );
};

